<template>
    <div class="member-info">
        <div class="avatar">
            <img :src="member.avatar" alt=""/>
        </div>
        <div class="info">
            <div class="name">{{ member.name }}</div>
            <div class="member-id">用户ID：{{ member.member_id }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'WTMember',
    props: {
        member: {
            type: Object,
            default: () => {
            }
        }
    }
}
</script>
<style lang="scss" scoped>

.member-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.info {
    margin-left: 10px;
}

.name {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 16px;
}

.member-id {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 12px;
    margin-top: 10px;
}

.avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    
    img {
        width: 100%;
        height: 100%;
    }
}
</style>